import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { TOption } from '@treezor/design-system';

import { IButtonField } from '@/ui-kit/table-filters/filters.type';

import { IAllWalletsFiltersFormFields } from '@/features/wallets/store/types/agent-wallets.types';
import { isTWalletTypeId, TWalletTypeId, walletTypeList } from '@/features/wallets/store/models/wallet.model';

import { useConfigWalletIdsList } from '@/features/wallets/hooks/useConfigWalletIdsList';

export function mapAllWalletsTypeId(value: TWalletTypeId) {
  return {
    walletTypeId: value,
  };
}

export function useAllWalletsTypeIdField(
  methods: UseFormReturn<IAllWalletsFiltersFormFields>,
  onChange,
): IButtonField<TWalletTypeId> {
  const { t } = useTranslation();

  const walletTypeIdList = useConfigWalletIdsList();

  const availableWalletTypes = walletTypeIdList.map((walletType: TOption | TWalletTypeId) => {
    const value = Number((walletType as TOption).value ? (walletType as TOption).value : walletType);
    const typeValue = isTWalletTypeId(value) ? value : undefined;
    return {
      label: t(`monetics.wallet.types.${walletTypeList[typeValue]}`),
      value: typeValue,
    };
  });

  const handleTypeIdChange = useCallback(
    (value: TWalletTypeId) => {
      methods.setValue('typeId', value);
      onChange();
    },
    [onChange, methods],
  );

  const value = availableWalletTypes.find((type) => methods.watch('typeId') === type.value);

  return {
    value: value?.value,
    handleChange: handleTypeIdChange,
    values: availableWalletTypes,
  };
}
